import { render, staticRenderFns } from "./ReferralTabs.vue?vue&type=template&id=0fba5d24&scoped=true"
import script from "./ReferralTabs.vue?vue&type=script&lang=js"
export * from "./ReferralTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fba5d24",
  null
  
)

export default component.exports